import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import Footer from './footer.js';

class Terms extends React.Component {
  render() {
    let terms = DataStore.getPageBySlug('privacy-statement');

    return (
      <div>
        <Layout>
          <section id="intro-section" className="intro-section">
            <h1>Testing Terms</h1>
            {terms}
          </section>
        </Layout>
        <Footer />
      </div>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/scripts/components/terms.js